<script>
export default {
  name: "Breadcrumb",
  props: {
    // Exemplo: [{ text: 'Lista', to: '/lista' }, { text: 'Criar', active: true }]
    items: {
      type: Array,
      required: true,
      default: () => [],
    }
  }
}
</script>

<template>
  <nav class="breadcrumb" aria-label="breadcrumbs">
    <template v-for="(item, index) in items">
      <template v-if="!item.active && item.to">
        <a class="breadcrumb-item truncate" :href="item.to">
          {{ item.text }}
        </a>
      </template>
      <template v-else>
        <span class="breadcrumb-item truncate" :class="{ 'active': item.active }" :aria-current="item.active ? 'page' : null">
          {{ item.text }}
        </span>
      </template>
      <span v-if="index < items.length - 1" class="breadcrumb-separator">/</span>
    </template>
  </nav>
</template>

<style scoped lang="stylus">
.breadcrumb {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}
.breadcrumb-item {
  cursor: pointer;
}
.breadcrumb-item:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
.breadcrumb-item.active {
  color: #1f2937;
  font-weight: 600;
  cursor: default;
}
.breadcrumb-item.active:hover {
  text-decoration: none;
}
.breadcrumb-separator {
  margin: 0 0.5rem;
  color: #9ca3af;
}
</style>
